import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5d0fd3d9&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=5d0fd3d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0fd3d9",
  null
  
)

export default component.exports